import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=24e50ede"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js"
import style0 from "./WelcomeMessage.vue?vue&type=style&index=0&id=24e50ede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports